import { render, staticRenderFns } from "./UnderWritingQuestionsList.vue?vue&type=template&id=441dbee3"
import script from "./UnderWritingQuestionsList.vue?vue&type=script&lang=ts"
export * from "./UnderWritingQuestionsList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports